import React from 'react'
import { IconButton, IconButtonProps } from 'rsuite'

const buttonStyle = {
    // background: 'var(--rs-btn-primary-bg)',
    // color: 'var(--rs-btn-primary-text)',
    borderRadius: 0,
}

export default ({ children, ...rest }: IconButtonProps) => {
    return (
        <IconButton {...rest} style={buttonStyle} >
            {children}
        </IconButton>
    )
}
